export default "__VITE_ASSET__BLMmoayi__"